import React, {forwardRef, useEffect, useState} from 'react';
import {Category} from "@models/category";
import {Col, Form, Row} from "antd";
import {FormattedMessage} from 'react-intl';
import CategoriesSelection, {CategoryMultiSelectionReturnValue} from "@components/categories/Selection";
import {SelectionMode} from "@models/index";
import {CategoryType} from "@models/category";

type VideoCategorySelectionProps = {
  onChange: (value: CategoryMultiSelectionReturnValue) => void
  selectedCategories: Category[],
  isDuplicatedForm?:boolean
}


/**
 * This component handles categories of a video
 * Witch has 3 category multi selection with different types
 * @param props
 * @param ref
 * @constructor
 */
function VideoCategorySelection(props: VideoCategorySelectionProps, ref) {
  const {form, selectedCategories = [], onChange , isDuplicatedForm} = props;
  const {getFieldDecorator} = form;
  const [allCategories, setAllCategories] = useState({
    [CategoryType.GENRE]: {},
    [CategoryType.TERRITORY]: {},
    [CategoryType.DEFAULT]: {}
  });
  
  const [selectedGenreCategories, setSelectedGenreCategories] = useState([]);
  const [selectedTerritoryCategories, setSelectedTerritoryCategories] = useState([]);
  const [selectedDefaultCategories, setSelectedDefaultCategories] = useState([]);
  
  useEffect(() => {
    setSelectedGenreCategories(selectedCategories.filter(item => item.type === CategoryType.GENRE))
    setSelectedTerritoryCategories(selectedCategories.filter(item => item.type === CategoryType.TERRITORY))
    setSelectedDefaultCategories(selectedCategories.filter(item => item.type === CategoryType.DEFAULT))
  }, [selectedCategories]);

const handleSelectedForDuplicate =(type : string , newValues )=>{
    let _temp: any = Array.from(newValues)

    const selectedItems = type === 'genre' ? Array.from(selectedGenreCategories) : type === 'territory' ? Array.from(selectedTerritoryCategories) : Array.from(selectedDefaultCategories)

    if(selectedItems && selectedItems.length > 0) {
     selectedItems.map((i: any)=> _temp.push(i.id) ) 
    }
    return _temp
}
  
  const onChangeCategories = (categories: CategoryMultiSelectionReturnValue, type: CategoryType) => {
    const lasCategories = {
      ...allCategories,
      [type]: categories
    };
    setAllCategories(lasCategories);
    
    let new_categories = [];

    let deleted_categories = [];
    for (let type in lasCategories) {                  
      const new_c =  lasCategories[type]["new_categories"] || []
      const del_c = lasCategories[type]["deleted_categories"] || []
      new_categories = isDuplicatedForm ?  [...new_categories, ...handleSelectedForDuplicate(type , new_c)] : [...new_categories, ...new_c]
      deleted_categories = [...deleted_categories, ...del_c] 
    }

    onChange({
      new_categories,
      deleted_categories
    })
  };
  
  return (
    <Row gutter={24}>
      <Col span={24}>
        <Form.Item label={<FormattedMessage id="app.genre" defaultMessage={`Genre`}/>}>
          {getFieldDecorator("category.genre", {})(
            <CategoriesSelection mode={SelectionMode.MULTIPLE}
                                 filter={{
                                   type: CategoryType.GENRE
                                 }}
                                 onChange={(data) => onChangeCategories(data, CategoryType.GENRE)}
                                 initialValue={selectedGenreCategories || []}/>
          )}
        </Form.Item>
      </Col>
      
      <Col span={24}>
        <Form.Item label={<FormattedMessage id="app.territory" defaultMessage={`Territory`}/>}>
          {getFieldDecorator("category.cat3", {})(
            <CategoriesSelection mode={SelectionMode.MULTIPLE}
                                 filter={{
                                   type: CategoryType.TERRITORY
                                 }}
                                 onChange={(data) => onChangeCategories(data, CategoryType.TERRITORY)}
                                 initialValue={selectedTerritoryCategories || []}/>
          )}
        </Form.Item>
      </Col>
      
      <Col span={24}>
        <Form.Item label={<FormattedMessage id="app.other_categories" defaultMessage={`Other Categories`}/>}>
          {getFieldDecorator("category.default", {})(
            <CategoriesSelection mode={SelectionMode.MULTIPLE}
                                 filter={{
                                   type: CategoryType.DEFAULT
                                 }}
                                 onChange={(data) => onChangeCategories(data, CategoryType.DEFAULT)}
                                 initialValue={selectedDefaultCategories || []}/>
          )}
        </Form.Item>
      </Col>
    
    </Row>
  )
}

export default forwardRef(VideoCategorySelection);